if (!window.Eurus.loadedScript.has('product-media.js')) {
  window.Eurus.loadedScript.add('product-media.js');

  // ---------------------------------------------------------------------------
  // Pinch / double-tap zoom for the PDP image overlay (2026-09-14).
  //
  // Vince: "On mobile, it's key to be able to tap an image and pinch to zoom in,
  // since images are small." Tapping already opened the overlay; this adds the
  // magnify step once it is open.
  //
  // The image carries transform-origin: 0 0 (see media-gallery.liquid), so with
  // transform: translate(tx,ty) scale(s) the visual top-left is simply
  // base + t, and a content point c lands at base + t + c*s. That keeps the
  // anchoring maths below trivial: c = (m - base - t) / s, then t' = m - base - c*s'.
  // ---------------------------------------------------------------------------
  window.Eurus.bindPinchZoom = function (img, root) {
    if (!img || !root || img.dataset.pinchBound === 'true') return null;
    img.dataset.pinchBound = 'true';

    var MIN = 1, MAX = 4, DOUBLE_TAP_SCALE = 2.5;
    var scale = 1, tx = 0, ty = 0;
    var baseLeft = 0, baseTop = 0, baseW = 0, baseH = 0;
    var startDist = 0, startScale = 1, startTx = 0, startTy = 0, midX = 0, midY = 0;
    var panning = false, panStartX = 0, panStartY = 0;
    var lastTapTime = 0, lastTapX = 0, lastTapY = 0;

    function measure() {
      var r = img.getBoundingClientRect();
      baseLeft = r.left - tx;
      baseTop = r.top - ty;
      baseW = r.width / scale;
      baseH = r.height / scale;
    }

    function clamp() {
      if (scale <= MIN) { tx = 0; ty = 0; return; }
      var vw = root.clientWidth, vh = root.clientHeight;
      var w = baseW * scale, h = baseH * scale;
      if (w <= vw) {
        tx = (vw - w) / 2 - baseLeft;
      } else {
        tx = Math.min(-baseLeft, Math.max(vw - baseLeft - w, tx));
      }
      if (h <= vh) {
        ty = (vh - h) / 2 - baseTop;
      } else {
        ty = Math.min(-baseTop, Math.max(vh - baseTop - h, ty));
      }
    }

    function apply() {
      if (scale <= MIN + 0.001) {
        scale = MIN; tx = 0; ty = 0;
        img.style.transform = '';
        img.classList.remove('is-pinched', 'is-panning');
        root.classList.remove('pdp-zoom-locked');
        return;
      }
      img.classList.add('is-pinched');
      root.classList.add('pdp-zoom-locked');
      img.style.transform = 'translate(' + tx + 'px, ' + ty + 'px) scale(' + scale + ')';
    }

    function zoomTo(newScale, mx, my) {
      measure();
      newScale = Math.min(MAX, Math.max(MIN, newScale));
      var cx = (mx - baseLeft - tx) / scale;
      var cy = (my - baseTop - ty) / scale;
      tx = mx - baseLeft - cx * newScale;
      ty = my - baseTop - cy * newScale;
      scale = newScale;
      clamp();
      apply();
    }

    function dist(t1, t2) {
      var dx = t1.clientX - t2.clientX, dy = t1.clientY - t2.clientY;
      return Math.sqrt(dx * dx + dy * dy);
    }

    function onStart(e) {
      if (e.touches.length === 2) {
        e.preventDefault();
        measure();
        startDist = dist(e.touches[0], e.touches[1]);
        startScale = scale; startTx = tx; startTy = ty;
        midX = (e.touches[0].clientX + e.touches[1].clientX) / 2;
        midY = (e.touches[0].clientY + e.touches[1].clientY) / 2;
        panning = false;
      } else if (e.touches.length === 1) {
        var now = Date.now(), x = e.touches[0].clientX, y = e.touches[0].clientY;
        if (now - lastTapTime < 300 && Math.abs(x - lastTapX) < 30 && Math.abs(y - lastTapY) < 30) {
          e.preventDefault();
          zoomTo(scale > MIN ? MIN : DOUBLE_TAP_SCALE, x, y);
          lastTapTime = 0;
          return;
        }
        lastTapTime = now; lastTapX = x; lastTapY = y;
        if (scale > MIN) {
          measure();
          panning = true;
          panStartX = x - tx; panStartY = y - ty;
          img.classList.add('is-panning');
        }
      }
    }

    function onMove(e) {
      if (e.touches.length === 2 && startDist > 0) {
        e.preventDefault();
        var d = dist(e.touches[0], e.touches[1]);
        var next = Math.min(MAX, Math.max(MIN, startScale * (d / startDist)));
        var cx = (midX - baseLeft - startTx) / startScale;
        var cy = (midY - baseTop - startTy) / startScale;
        tx = midX - baseLeft - cx * next;
        ty = midY - baseTop - cy * next;
        scale = next;
        clamp();
        apply();
      } else if (panning && e.touches.length === 1) {
        e.preventDefault();
        tx = e.touches[0].clientX - panStartX;
        ty = e.touches[0].clientY - panStartY;
        clamp();
        apply();
      }
    }

    function onEnd(e) {
      if (e.touches.length === 0) {
        startDist = 0;
        panning = false;
        img.classList.remove('is-panning');
        if (scale <= MIN) apply();
      }
    }

    img.addEventListener('touchstart', onStart, { passive: false });
    img.addEventListener('touchmove', onMove, { passive: false });
    img.addEventListener('touchend', onEnd);
    img.addEventListener('touchcancel', onEnd);

    return function teardown() {
      img.removeEventListener('touchstart', onStart);
      img.removeEventListener('touchmove', onMove);
      img.removeEventListener('touchend', onEnd);
      img.removeEventListener('touchcancel', onEnd);
      scale = 1; tx = 0; ty = 0;
      img.style.transform = '';
      img.classList.remove('is-pinched', 'is-panning');
      root.classList.remove('pdp-zoom-locked');
      delete img.dataset.pinchBound;
    };
  };

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xProductMedia', (settings) => ({
        thumbnailOnMouseDown: false,
        thumbnailOfset: 0,
        thumbnailScrollOfset: 0,
        thumbnailGrabbingClass: '',
        zoomIsOpen: false,
        productMediaIsOpen: '',
        videoExternalListened: false,
        xPosition: 0,
        yPosition: 0,
        imageWidth: 0,
        imageHeight: 0,
        startZoom(event) {
          const elem = event.currentTarget;
          const size = elem.getBoundingClientRect();
          this.xOffset = size.left;
          this.yOffset = size.top;
          this.imageWidth = size.width;
          this.imageHeight = size.height;
        },
        updatePosition(event) {
          if (this.imageWidth && this.imageHeight) {
            this.xPosition = ((event.clientX - this.xOffset) / this.imageWidth) * 100;
            this.yPosition = ((event.clientY - this.yOffset)  / this.imageHeight) * 100;
          }
        },
        thumbnailHandleMouseDown(e) {
          this.thumbnailOnMouseDown = true;
          this.thumbnailGrabbingClass = 'cursor-grabbing';
          if (settings.thumbnail_direction == 'horizontal') {
            this.thumbnailOfset = e.pageX - this.$refs.thumbnail.offsetLeft;
            this.thumbnailScrollOfset = this.$refs.thumbnail.scrollLeft;
          } else {
            this.thumbnailOfset = e.pageY - this.$refs.thumbnail.offsetTop;
            this.thumbnailScrollOfset = this.$refs.thumbnail.scrollTop;
          }
        },
        thumbnailHandleMouseMove(e) {
          if(!this.thumbnailOnMouseDown) return;
          e.preventDefault();
          if (settings.thumbnail_direction == 'horizontal') {
            const x = e.pageX - this.$refs.thumbnail.offsetLeft;
            const walk = (x - this.thumbnailOfset) * 2; 
            this.$refs.thumbnail.scrollLeft = this.thumbnailScrollOfset - walk;
          }
          else {
            const y = e.pageY - this.$refs.thumbnail.offsetTop;
            const walk = (y - this.thumbnailOfset) * 2; 
            this.$refs.thumbnail.scrollTop = this.thumbnailScrollOfset - walk;
          }
        },
        thumbnailHandleMouseLeave() {
          this._thumbnailRemoveGrabing();
        },
        thumbnailHandleMouseUp() {
          this._thumbnailRemoveGrabing();
        },
        _thumbnailRemoveGrabing() {
          this.thumbnailOnMouseDown = false;
          this.thumbnailGrabbingClass = 'md:cursor-grab';
        },
        // Zoom is configured separately for desktop and mobile. The overlay markup is
        // rendered once and shared, so the per-device on/off decision has to happen
        // here at click time rather than in Liquid.
        zoomAllowedForViewport() {
          const bp = settings.zoom_breakpoint || 768;
          const isDesktop = window.matchMedia(`(min-width: ${bp}px)`).matches;
          const flag = isDesktop ? settings.zoom_desktop : settings.zoom_mobile;
          // undefined means an older section that never got the per-device settings;
          // those should keep their previous behaviour.
          return flag === undefined ? true : flag;
        },
        zoomOpen(position, isSplide) {
          if (!this.zoomAllowedForViewport()) return;
          this.zoomIsOpen = true;
          Alpine.store('xPopup').open = true;
          setTimeout(() => {
            if (isSplide) {
              const splideEl = document.getElementById(`media-gallery-${settings.section_id}`)
              if (splideEl && splideEl.splide) {
                let nextSlideIndex = 0;
                const childrenArray = Array.from(splideEl.querySelector('.splide__list').children)
                childrenArray.map((item, index) => {
                  if (item.getAttribute('x-slide-index') == position) {
                    nextSlideIndex = index
                  }
                })
                splideEl.splide.go(nextSlideIndex);
              }
              document.addEventListener(`eurus:zoom-image-ready:${settings.section_id}`, () => {
                if (splideEl && splideEl.splide) {
                  let nextSlideIndex = 0;
                  const childrenArray = Array.from(splideEl.querySelector('.splide__list').children)
                  childrenArray.map((item, index) => {
                    if (item.getAttribute('x-slide-index') == position) {
                      nextSlideIndex = index
                    }
                  })
                  splideEl.splide.go(nextSlideIndex);
                }
              });
            }
            else {
              document.getElementById(position + '-image-zoom-' + settings.section_id).scrollIntoView({ behavior: 'smooth', block: 'start' })
            }
          }, 200);
          Alpine.store('xModal').activeElement = 'product-image-' + settings.section_id + '-' + position;
          if (settings.zoom_pinch) {
            setTimeout(() => this.zoomPinchInit(), 300);
          }
        },
        zoomPinchInit() {
          const root = document.getElementById('ProductModal-' + settings.section_id);
          if (!root) return;
          this.zoomPinchDestroy();
          this._pinchTeardown = Array.from(root.querySelectorAll('.pdp-zoom-pinch'))
            .map((img) => window.Eurus.bindPinchZoom(img, root));
        },
        zoomPinchDestroy() {
          if (!this._pinchTeardown) return;
          this._pinchTeardown.forEach((fn) => fn && fn());
          this._pinchTeardown = null;
        },
        zoomClose() {
          this.zoomPinchDestroy();
          this.zoomIsOpen = false;
          Alpine.store('xPopup').close();
        },
        
        videoHandleIntersect() {
          if (settings.video_autoplay) {
            Alpine.store('xVideo').play(this.$el);
          }
        },
        productModelInit() {
          window.Shopify.loadFeatures([
            {
              name: 'shopify-xr',
              version: '1.0',
              onLoad: this._productModelSetupShopifyXR,
            },
          ]);
        },
        _productModelSetupShopifyXR() {
          const setup = () => {
            document.querySelectorAll('[id^="ProductJSON-"]').forEach((modelJSON) => {
              window.ShopifyXR.addModels(JSON.parse(modelJSON.textContent));
              modelJSON.remove();
            });
            window.ShopifyXR.setupXRElements();
          }
  
          if (!window.ShopifyXR) {
            document.addEventListener('shopify_xr_initialized', () => {
              setup();
            });
            return;
          }
      
          setup();
        },
        productModelLoadMedia() {
          let container = this.$el.parentNode;
          const content = document.createElement('div');
          content.appendChild(container.querySelector('template').content.firstElementChild.cloneNode(true));
  
          this.$el.classList.add('hidden');
          container.appendChild(content.querySelector('model-viewer'));
  
          this._productModelLoadViewerUI();
        },
        productModelPauseViewer() {
          if (this.$el.modelViewerUI) this.$el.modelViewerUI.pause();
        },
        _productModelLoadViewerUI() {
          window.Shopify.loadFeatures([
            {
              name: 'model-viewer-ui',
              version: '1.0',
              onLoad: this._productModelSetupViewerUI.bind(this),
            },
          ]);
        },
        _productModelSetupViewerUI(errors) {
          if (errors) return;
  
          this.$el.parentNode.modelViewerUI
            = new Shopify.ModelViewerUI(this.$el.parentNode.querySelector('model-viewer')); 
        }
      }));
    });
  });
}